// A minimal Server-Sent Events parser for streams read with fetch (POST /quote cannot use
// EventSource). Feed it chunks; it returns complete frames. Comment lines (keepalives) are dropped.

export type SseFrame = { event: string; id?: string; data: string };

export class SseParser {
  private buf = "";

  push(chunk: string): SseFrame[] {
    // normalize the whole buffer: a frame's "\r" and "\n" can arrive in separate chunks
    this.buf = (this.buf + chunk).replace(/\r\n/g, "\n");
    const out: SseFrame[] = [];
    let i: number;
    while ((i = this.buf.indexOf("\n\n")) >= 0) {
      const block = this.buf.slice(0, i);
      this.buf = this.buf.slice(i + 2);
      let event = "message";
      let id: string | undefined;
      const data: string[] = [];
      for (const line of block.split("\n")) {
        if (line === "" || line.startsWith(":")) continue;
        const c = line.indexOf(":");
        const field = c < 0 ? line : line.slice(0, c);
        const value = c < 0 ? "" : line.slice(c + 1).replace(/^ /, "");
        if (field === "event") event = value;
        else if (field === "id") id = value;
        else if (field === "data") data.push(value);
      }
      if (data.length) out.push({ event, id, data: data.join("\n") });
    }
    return out;
  }
}

/** Read a fetch Response as SSE, calling `onFrame` per frame until the stream ends. */
export async function readSse(res: Response, onFrame: (f: SseFrame) => void): Promise<void> {
  if (!res.body) throw new Error("no response body");
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  const p = new SseParser();
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    for (const f of p.push(dec.decode(value, { stream: true }))) onFrame(f);
  }
}
